import { render, staticRenderFns } from "./controlDetail.vue?vue&type=template&id=e87f402e&"
import script from "./controlDetail.vue?vue&type=script&lang=js&"
export * from "./controlDetail.vue?vue&type=script&lang=js&"
import style0 from "./controlDetail.vue?vue&type=style&index=0&id=e87f402e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports